import React, { useRef } from "react";
import removeFileImg from "../asserts/img/removeFile.svg";
import { useTheme } from "styled-components";

export const ExtentionPreview = ({ files, onRemove }) => {
  const theme = useTheme();
  const inputRef = useRef(null);

  const handleRemoveFile = (file) => {
    onRemove(file);
    inputRef.current.value = "";
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px 20px",
      }}>
      {files?.map((file, i) => (
        <div
          key={i}
          style={{
            border: `1.4px solid ${theme.color.label}`,
            backgroundColor: theme.color.white,
            color: theme.color.label,
            borderRadius: 20,
            padding: 5,
            fontSize: 16,
            fontWeight: 500,
            display: "inline-flex",
            flexDirection: "row",
            height: 36,
            width: "33%",
            minWidth: 110,
          }}>
          <div
            style={{
              marginInlineEnd: "1em",
              overflow: "hidden",
              whiteSpace: "wrap",
              textOverflow: "ellipsis",
              textAlign: "start",
            }}>
            {file?.EXTFILEDES}
          </div>
          <img
            src={removeFileImg}
            alt="rermove"
            onClick={() => handleRemoveFile(file)}
          />
        </div>
      ))}
    </div>
  );
};

export default ExtentionPreview;
